

































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import InputUTXO from '@/components/rows/TxRow/InputUtxo.vue'
import OutputUTXO from '@/components/rows/TxRow/OutputUtxo.vue'
import {
    Transaction,
    getTransactionOutputs,
    getTransactionInputs,
} from '@/js/Transaction'
import {
    DEFAULT_NETWORK,
    DEFAULT_NETWORK_NAME,
} from '@/store/modules/network/network'
import { getTastChainType } from '@/known_blockchains'
import { getMappingForType } from '@/store/modules/transactions/maps'
import CopyText from '@/components/misc/CopyText.vue'

@Component({
    components: {
        InputUTXO,
        OutputUTXO,
        CopyText,
    },
    filters: {
        getType: getMappingForType,
    },
})
export default class TxRow extends Vue {
    @Prop() transaction!: Transaction

    get isGenesisVertex(): boolean {
        const genesisTxID = DEFAULT_NETWORK.dcmId
        return this.transaction.id === genesisTxID ? true : false
    }
    get isAsset() {
        const asset = window.location.href.includes('asset')
        return asset
    }
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
    get chainCode() {
        return getTastChainType(this.transaction.chainID)!.code
    }

    get chainColor() {
        return getTastChainType(this.transaction.chainID)!.color
    }

    get chainDarkColor() {
        return getTastChainType(this.transaction.chainID)!.darkColor
    }

    shortenId(id: string, pad: number) {
        return `${id.substring(0, pad)}...${id.substring(
            id.length - pad,
            id.length
        )}`
    }

    get type() {
        return getMappingForType(this.transaction.type)
    }

    /**
     * Returns a list of unique addresses found in Input UTXOs
     */
    get inputs() {
        const addresses = getTransactionInputs(this.transaction.inputs).flatMap(
            (output) => output.output.addresses
        )

        /**
         * This is just making sure that the addresses is a unique set with no repeats
         */
        return Array.from(
            new Set(addresses.map((address) => address.address))
        ).map((address) => {
            return {
                address,
                ...addresses.find((a) => a.address === address),
            }
        })
    }

    get outputs() {
        return getTransactionOutputs(this.transaction.outputs).slice(0, 2)
    }

    get outputLength() {
        return getTransactionOutputs(this.transaction.outputs).length
    }

    goToTx() {
        this.$router.push(
            `/tx/${this.transaction.id}?network=${DEFAULT_NETWORK_NAME}`
        )
    }
}
